import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pad'
})
export class PadPipe implements PipeTransform {

  transform(value: string | number, length: number, char: string, direction: 'start' | 'end' = 'start'): string {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value);

    return direction === 'start' ? stringValue.padStart(length, char) : stringValue.padEnd(length, char);
  }
}

